/**
 * 
 * key
 * 
 */


const key = 'Y2xpZW50VmlzaXRSZXBvcnQ='

export default key 